const colors = {
  brand: '#fc580a',
  white: '#ffffff',
  black: '#302d44',
  grey100: '#eaeaea',
  grey300: '#c0c0c6',
  grey700: '#6e6c7c',
  grey800: '#595769',
  grey900: '#434155',
  ice: '#f3f3f5',
};

export default {
  colors,
  account: {
    backgroundColor: colors.brand,
    backgroundColorMobile: colors.white,
  },
  box: {
    backgroundColor: colors.white,
  },
};
